require('./insuranceRequestWizardStep4.scss');
require('./insuranceRequestWizardStep4.override.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');
const Geosuggest = require('react-geosuggest').default;
const classnames = require('classnames');
const isEqual = require('lodash/lang/isEqual');

// @ helpers
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { toFirstUppercase, stringToBoolean, cleanUpAccents, toCamelCase } = require('utilities/stringHelper');

// @ constants
const { DATE_PICKER_CUSTOM_PLACEHOLDER, DATE_PICKER_CUSTOM_LOCALE, DATE_PICKER_CUSTOM_DATE_FORMAT } = require('constants/commonsComponents');
const {
    WEB_INACTIVE_ACCOUNT_ENABLED,
    STEP_FOUR_POPULATION_ENABLED,
    INSURANCE_IDD_REGULATION,
    STANDALONE_RELATED_INSURANCE,
} = require('constants/flagBasedFeatures');
const {
    MAX_DAYS_INSURANCE_INIT,
    TARGET_COUNTRY,
    DISCLAIMER_CONTEXT,
} = require('../../../insuranceConstants/insuranceRequestHome');

const {
    typeOfInputs,
    validationsForInputs,
    errors,
    selectAddresState,
} = require('../../../insuranceConstants/insuranceRequestHomeAddress');
const {
    FOURTH_STEP,
    WIZARD_SECOND_STEP,
} = require('constants/index');

// @common-components
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKInput } = require('commonsComponents/OKInput');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { DatePickerCustom } = require('commonsComponents/datePickerCustom');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKAutosuggest } = require('commonsComponents/OKAutosuggest');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ components
const OKSelect = require('components/commons/OKSelect/OKSelect');
const InsuranceRequestWizardStep4DatePicker = require('./insuranceRequestWizardStep4Components/insuranceRequestWizardStep4DatePicker')
const InsuranceRequestWizardStep4AccountSection = require('./insuranceRequestWizardStep4Components/insuranceRequestWizardStep4AccountSection')
const InsuranceRequestWizardGDPRMessage = require('../insuranceRequestWizardGDPRMessage/insuranceRequestWizardGDPRMessage');
const InsuranceRequestBuildPaymentType = require('../insuraceRequestBuildPaymentType/insuranceRequetsBuildPaymentType')
class InsuranceRequestWizardStep4 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            addressError: false,
            showDisclaimer: false,
            showExample: true,
            showNoResultsMessage: false,
            showAddressFields: false,
            roadTypeIsEmpty: false,
            postalCodeError: false,
            [`${typeOfInputs.number}Error`]: '',
            [`${typeOfInputs.population}Error`]: '',
            [`${typeOfInputs.road}Error`]: '',
            [`${typeOfInputs.additionalInfo}Error`]: '',
            userSelectAddressNumber: selectAddresState.initial,
            geosuggestInitialValue: '',
            oldPricing: null,

        };

        this.onhandlePaymentTypeChange = this.onhandlePaymentTypeChange.bind(this);
        this.onhandleDateChange = this.onhandleDateChange.bind(this);
        this.onhandleAccountChange = this.onhandleAccountChange.bind(this);
        this.handleCompleteManually = this.handleCompleteManually.bind(this);
        this.handleSelectAddress = this.handleSelectAddress.bind(this);
        this.handleBlurAddress = this.handleBlurAddress.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.handleChangePostalCodeStep = this.handleChangePostalCodeStep.bind(this);
        this.handleOnChangeAddress = this.handleOnChangeAddress.bind(this);
        this.handleHasMortgageChange = this.handleHasMortgageChange.bind(this);
        this.handleMortgageBankChange = this.handleMortgageBankChange.bind(this);
        this.handleMortgageBankSelected = this.handleMortgageBankSelected.bind(this);
        this.handleOnSuggestNoResults = this.handleOnSuggestNoResults.bind(this);
        this.handleRoadTypeBlur = this.handleRoadTypeBlur.bind(this);
        this.handleValidateField = this.handleValidateField.bind(this);
        this.handleBlurField = this.handleBlurField.bind(this);
        this.handleBlurAdditionalInfoField = this.handleBlurAdditionalInfoField.bind(this);
        this.buildError = this.buildError.bind(this);
    }

    componentWillMount() {
        const { getPaymentAccount } = this.props;
        getPaymentAccount().then(() => {
            const { immInsuranceWizardStep } = this.props;
            this.onhandleAccountChange(immInsuranceWizardStep.get('accountId'));
        });
    }

    componentDidMount() {
        const {
            getMortgageBanks,
            requestInsuranceProvinces,
            isRelated,
            setData,
            postalCode,
            immInsuranceState
        } = this.props;
        const propertyType = immInsuranceState.getIn(['data', 'home', 'propertyType']) || '';
        const shouldValidateAdditionalInfo = propertyType === 'APARTMENT' || propertyType === 'PENTHOUSE'
        if (!isRelated) {
            setData(FOURTH_STEP, {
                provinceId: postalCode.slice(0, 2),
                shouldValidateAdditionalInfo,
            });

            this.checkPreviousAddressValues();
            this.getGeoSuggestInitialValue();

            requestInsuranceProvinces && requestInsuranceProvinces();
            getMortgageBanks && getMortgageBanks();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { immInsuranceState, immInsuranceWizardStep, setData, postalCode } = nextProps;
        const currentRoadTypeName = this.props.immInsuranceWizardStep.get('roadTypeName');
        const nextRoadTypeName = immInsuranceWizardStep.get('roadTypeName');
        if (!currentRoadTypeName && nextRoadTypeName) {
            this.getGeoSuggestInitialValue(nextRoadTypeName);
        }

        const paymentType = immInsuranceWizardStep.get('paymentType').toLowerCase();
        const plan = immInsuranceState.getIn(['data', 'insurancePlan']).toLowerCase();
        const firstImport = immInsuranceWizardStep.getIn(['pricing', paymentType, plan, 'firstImport']);

        if (firstImport) {
            setData(FOURTH_STEP, {
                totalCost: firstImport
            });
        }

        if (
            postalCode !== immInsuranceState.getIn(['data', 'home', 'postalCode']) &&
            immInsuranceWizardStep.get('road')
        ) {
            this._geoSuggest.selectSuggest();
        }
    }

    checkPreviousAddressValues() {
        const { immInsuranceWizardStep, setData } = this.props;

        const roadType = immInsuranceWizardStep.get('roadType');
        const road = immInsuranceWizardStep.get('road');
        const number = immInsuranceWizardStep.get('number');
        const additionalInfo = immInsuranceWizardStep.get('additionalInfo');
        const population = immInsuranceWizardStep.get('population');

        const addressFields = [roadType, road, number, additionalInfo, population];
        const hasPreviousAddressValues = addressFields.some((val) => val !== '' && val !== null);
        this.setState({ showAddressFields: hasPreviousAddressValues });

        if (roadType && road && population && !number) {
            setData(FOURTH_STEP, { number: 's/n' });
        }
    }

    onhandlePaymentTypeChange(paymentType) {
        const { setData, immInsuranceState, immInsuranceWizardStep } = this.props;

        const plan = immInsuranceState.getIn(['data', 'insurancePlan']).toLowerCase();
        const totalCost = immInsuranceWizardStep.getIn(['pricing', paymentType.toLowerCase(), plan, 'firstImport']);

        setData(FOURTH_STEP, {
            paymentType,
            totalCost
        });
    }

    onhandleDateChange(value) {
        this.props.setData(FOURTH_STEP, {
            startDate: value
        });
    }

    onhandleAccountChange(accountId) {
        const { immAccounts, setData } = this.props;

        if (!!accountId) {
            const immAccount = immAccounts.getIn(['byId', accountId]);
            setData(FOURTH_STEP, {
                accountId,
                accountBalance: immAccount.getIn(['balance', 'amount']),
                accountIBAN: immAccount.get('iban')
            });
        }
    }

    handleBlurAddress(value) {
        const fieldIsEmpty = !value.length;
        const { showAddressFields, userSelectAddressNumber, showNoResultsMessage } = this.state;

        this.setState({
            addressError: showAddressFields ? false : fieldIsEmpty,
            showDisclaimer: false,
            showExample: true,
            userSelectAddressNumber: showNoResultsMessage ? selectAddresState.initial : userSelectAddressNumber === selectAddresState.selected ? selectAddresState.selected : selectAddresState.no_selected,
        });
    }

    handleOnFocus() {
        const { userSelectAddressNumber } = this.state;
        this.setState({
            showDisclaimer: true,
            showExample: false,
            addressError: false,
            showNoResultsMessage: false,
            userSelectAddressNumber: userSelectAddressNumber === selectAddresState.selected ? selectAddresState.selected : selectAddresState.initial,
        });
    }

    handleOnChangeAddress(value) {
        let newState = {};
        if (value && value.length > 0) {
            newState.showDisclaimer = false;
            newState.showNoResultsMessage = false;
        } else if (this.state.showDisclaimer === false) {
            newState.showDisclaimer = true;
            newState.showExample = false;
            newState.showNoResultsMessage = false;
            newState.addressError = false;
        }
        this.setState(newState);
    }

    handleOnSuggestNoResults(search) {
        if (search && search.length > 0) {
            if (!this.state.showDisclaimer) {
                this.setState({ showNoResultsMessage: true, showDisclaimer: false });
            }
        }
    }

    handleValidateField(event, field, required = true) {
        const { setData } = this.props;
        const { postalCodeError } = this.state;

        const inputTovalidate = validationsForInputs[field];
        const isFromInputEvent = event && event.target;
        const value = isFromInputEvent ? event.target.value : event;
        Object.keys(inputTovalidate).forEach((key) => {
            switch (key) {
                case "match":
                    const valueMatchWithRegex = inputTovalidate[key].test(value)
                    if (value.length === 0 && required) {
                        this.setState({ [`${field}Error`]: errors[field].EMPTY_DATA })
                    } else {
                        this.setState({ [`${field}Error`]: !valueMatchWithRegex ? errors[field].INVALID_DATA : '' })
                    }
                    isFromInputEvent && setData(FOURTH_STEP, { [field]: value });
                    break;
            }
        });
        if (postalCodeError && required) {
            this.setState({ postalCodeError: false })
        }
    }

    handleBlurField(event, field) {
        const { immInsuranceWizardStep, saveStep } = this.props;
        const { value } = event.target;
        const currentPopulation = immInsuranceWizardStep.get('population');
        const oldPricing = immInsuranceWizardStep.get('totalCost');

        if (value.length === 0) {
            this.setState({ [`${field}Error`]: errors[field].EMPTY_DATA })
        }

        if(field === typeOfInputs.population) {
            this.setState({ oldPricing });
        }

        if ( field === 'population' && !!currentPopulation ) {
            saveStep(FOURTH_STEP, true);
        }
    }

    handleBlurAdditionalInfoField(event, field) {
        const { immInsuranceWizardStep } = this.props;
        const shouldValidateAdditionalInfo = immInsuranceWizardStep.get('shouldValidateAdditionalInfo');
        if (shouldValidateAdditionalInfo) {
            this.handleBlurField(event, field);
        }
    }

    getGeoSuggestInitialValue(nextRoadTypeName) {
        const { immInsuranceWizardStep, postalCode } = this.props;
        const road = immInsuranceWizardStep.get('road');
        const roadTypeName = immInsuranceWizardStep.get('roadTypeName');
        const getRoadTypeName = roadTypeName || nextRoadTypeName;
        const showRoadTypeName = getRoadTypeName ? toFirstUppercase(getRoadTypeName) : '';
        const number = immInsuranceWizardStep.get('number');
        const population = immInsuranceWizardStep.get('population') ? `, ${immInsuranceWizardStep.get('population')}` : '';
        const existNumber = number && number.toLowerCase() !== 's/n' ? ` ${number},` : '';
        const geosuggestInitialValue = road ? `${showRoadTypeName} ${road},${existNumber} ${postalCode}${population}` : '';
        this.setState({ geosuggestInitialValue })
    }

    handleSelectAddress(suggest) {
        const { setData, postalCode, getAddressTypeList } = this.props;

        if (!suggest) {
            this._geoSuggest.clear();
            this.setState({ addressError: true, postalCodeError: false })
            return false;
        } else if (suggest && suggest.gmaps) {
            const locationItem = {
                number: '',
                postalCode: '',
                road: '',
                population: ''
            };

            suggest.gmaps.address_components
                .forEach(address => {
                    if (address.hasOwnProperty('types')) {
                        if (address.types.includes('street_number')) {
                            this.handleValidateField(address.long_name, typeOfInputs.number);
                            locationItem.number = address.long_name;
                        }
                        if (address.types.includes('postal_code')) {
                            locationItem.postalCode = address.long_name;
                        }
                        if (address.types.includes('route')) {
                            this.handleValidateField(address.long_name, typeOfInputs.road);
                            locationItem.road = address.long_name.toLowerCase() || '';
                        }
                        if (address.types.includes('locality')) {
                            this.handleValidateField(address.long_name, typeOfInputs.population);
                            locationItem.population = address.long_name.slice(0, validationsForInputs.population.length).toLowerCase() || '';
                        }
                    }
                });

            const roadType = locationItem.road !== '' ? this.filterRoadType(locationItem.road) : '';
            getAddressTypeList();
            const roadToupperCase = toFirstUppercase(locationItem.road);

            if (locationItem.road === '') {
                this.setState({
                    [`${typeOfInputs.road}Error`]: errors[typeOfInputs.road].EMPTY_DATA,
                    roadTypeIsEmpty: true
                })
            }
            if (locationItem.population === '') {
                this.setState({
                    [`${typeOfInputs.population}Error`]: errors[typeOfInputs.population].EMPTY_DATA,
                })
            }

            setData(FOURTH_STEP, {
                road: roadToupperCase.replace(roadType, '').slice(0, validationsForInputs.road.length).trim(),
                number: locationItem.number || 's/n',
            });

            this.setState({
                addressError: false,
                showExample: true,
                showDisclaimer: false,
                showAddressFields: true,
                postalCodeError: locationItem.postalCode !== postalCode,
                userSelectAddressNumber: selectAddresState.selected,
                geosuggestInitialValue: suggest.description
            })
        }
    }

    handleChangePostalCodeStep() {
        const { goBackStep } = this.props;
        goBackStep(WIZARD_SECOND_STEP);
    }

    handleHasMortgageChange(hasMortgage) {
        const { immInsuranceWizardStep } = this.props;

        const hasMortgageValue = stringToBoolean(hasMortgage);
        const mortgageBank = immInsuranceWizardStep.get('mortgageBank');
        const bankName = !hasMortgageValue && mortgageBank ? '' : mortgageBank;

        this.props.setData(FOURTH_STEP, {
            hasMortgage: hasMortgageValue,
            mortgageBank: bankName
        });
    }

    handleMortgageBankChange(value) {
        this.props.setData(FOURTH_STEP, {
            mortgageBank: value
        });
    }

    handleMortgageBankSelected(evt) {
        const bankName = evt.suggestion.name;
        this.props.setData(FOURTH_STEP, {
            mortgageBank: bankName
        });
    }

    renderDisclaimer(showDisclaimer, disclaimerContext) {

        if (!showDisclaimer) return null;

        const { POSTAL_CODE } = DISCLAIMER_CONTEXT;
        const messages = {
            POSTAL_CODE: "insuranceRequestHome-step4MismatchedPostalCode",
            ADDRESS: "insuranceRequestHome-step4DisclaimerResponseOfGeoSuggest",
        };
        const disclaimerMessage = messages[disclaimerContext];
        const disclaimerClass = classnames('insurance-request-wizard-step-four__disclaimer', {
            'insurance-request-wizard-step-four__disclaimer-postalcode': disclaimerContext === POSTAL_CODE
        });

        return (
            <div className={disclaimerClass}>
                <span className="insurance-request-wizard-step-four__disclaimer-paragraph">
                    <i className="insurance-request-wizard-step-four__disclaimer-icon icon-advertencia" />
                    <FormattedText value={disclaimerMessage} />
                </span>
            </div>
        );
    }

    handleCompleteManually() {
        this.setState({ showAddressFields: true, showNoResultsMessage: false, userSelectAddressNumber: selectAddresState.selected, });
    }

    renderExample() {
        if (!this.state.showExample) return null;

        return (
            <div className="insurance-request-wizard-step-four__error-container">
                {formatText('insuranceRequestHome-step4AddressExample')}
            </div>
        );
    }

    renderCompleteManually() {
        if (!this.state.showNoResultsMessage) return null;

        return (
            <div className="insurance-request-wizard-step-four__container-no-results">
                <ul className="insurance-request-wizard-step-four__no-results">
                    <li>
                        {formatText('insuranceRequestHome-step4noResults')}
                        <span className="insurance-request-wizard-step-four__no-results-link" onClick={this.handleCompleteManually}>
                            {formatText('insuranceRequestHome-step4manuallyComplete')}
                        </span>
                    </li>
                </ul>
            </div>
        );
    }

    getProvinceName(provinceId) {
        const { immInsuranceWizardStep } = this.props;

        const provinces = immInsuranceWizardStep.get('provinces').toJS();
        const provinceName = provinces[provinceId] && provinces[provinceId].name ? provinces[provinceId].name : '';

        return provinceName;
    }

    roadTypeOptions() {
        const { immInsuranceWizardStep } = this.props;
        const addressTypeList = immInsuranceWizardStep.get('addressTypeList');
        if (addressTypeList.size > 0) {
            const addressTypeListData = addressTypeList.get('data');
            const addressTypeFormat = addressTypeListData.map(roadType => {
                const label = toFirstUppercase(roadType.get('name'));
                const value = roadType.get('languageKey');
                return {
                    label,
                    value
                }
            });
            return addressTypeFormat.toArray();
        }
        return []
    }

    filterRoadType(roadName) {
        const { setData } = this.props;
        const roadTypeOptions = this.roadTypeOptions();
        const roadNameAccentClean = cleanUpAccents(roadName);
        const roadNameUpperCase = toFirstUppercase(roadNameAccentClean);

        const seekStreetType = roadTypeOptions.filter(road => {
            const roadAccentClean = cleanUpAccents(road.label);
            return roadNameUpperCase.includes(roadAccentClean);
        })
        const roadTypeLabel = seekStreetType.length > 0 ? seekStreetType[0].label : '';
        setData(FOURTH_STEP, {
            roadType: seekStreetType.length > 0 ? seekStreetType[0].value : '',
        });
        this.setState({
            roadTypeIsEmpty: !roadTypeLabel
        })
        return roadTypeLabel
    }

    handleChangeRoadType(roadType) {
        const { setData, getAddressTypeList } = this.props;

        this.setState({ roadTypeIsEmpty: false, postalCodeError: false });
        setData(FOURTH_STEP, {
            roadType: roadType.value.toUpperCase(),
        });
        getAddressTypeList();
    }

    handleRoadTypeBlur() {
        const { immInsuranceWizardStep } = this.props;
        const roadType = immInsuranceWizardStep.get('roadType');
        const roadTypeShowError = !roadType ? true : false;
        this.setState({ roadTypeIsEmpty: roadTypeShowError });
    }

    buildMaxCharactersMessage(inputName) {
        const maxCharactersMessage = (
            <FormattedText
                value="insuranceRequestHome-inputMaxNumberOfCharacters"
                injectedStrings={[validationsForInputs[inputName].length]}
            />
        )
        return maxCharactersMessage;
    }

    buildAdditionalAddressFields() {
        const {
            immFlagBasedFeatures,
            immInsuranceWizardStep,
            postalCode,
        } = this.props;
        const {
            numberError,
            roadTypeIsEmpty,
            roadError,
            additionalInfoError,
            populationError,
            postalCodeError,
        } = this.state;

        const { POSTAL_CODE } = DISCLAIMER_CONTEXT;
        const roadType = immInsuranceWizardStep.get('roadType') || null;
        const road = immInsuranceWizardStep.get('road') || '';
        const number = immInsuranceWizardStep.get('number') || '';
        const additionalInfo = immInsuranceWizardStep.get('additionalInfo') || '';
        const provinceId = immInsuranceWizardStep.get('provinceId');
        const provinceName = this.getProvinceName(provinceId);
        const population = immInsuranceWizardStep.get('population') || '';
        const fieldErrors = immInsuranceWizardStep.get('fieldErrors')
        const postalCodeClass = classnames('insurance-request-wizard-step-four insurance-request-wizard-step-four__postal-code col-md-4 ', {
            'insurance-request-wizard-step-four__postal-code--with-disclaimer': postalCodeError
        })
        const roadTypeErrorMessage = formatText('insuranceRequestHome-requiredFieldError');
        const roadErrorValidation = fieldErrors && !road ? errors.road.EMPTY_DATA : roadError
        const populationErrorValidation = fieldErrors && !population ? errors.population.EMPTY_DATA : populationError
        const numberErrorValidation = fieldErrors && !number ? errors.number.EMPTY_DATA : numberError
        const roadTypeErrorValidation = fieldErrors && !roadType || roadTypeIsEmpty
        const shouldValidateAdditionalInfo = immInsuranceWizardStep.get('shouldValidateAdditionalInfo')
        const additionalInfoErrorValidation = fieldErrors && !additionalInfo && shouldValidateAdditionalInfo ? errors.additionalInfo.EMPTY_DATA : additionalInfoError
        const additionalInfoLabel = <FormattedText value="insuranceRequestHome-step4AdditionalInfo" />;
        const stepFourPopulationEnabled = immFlagBasedFeatures.get(STEP_FOUR_POPULATION_ENABLED);
        const populationDisabledStatus = !stepFourPopulationEnabled || immInsuranceWizardStep.get('isSaving') || immInsuranceWizardStep.get('isFetchingPricing');
        const roadTypeOptions = this.roadTypeOptions() || [];

        return (
            <React.Fragment>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="insurance-request-wizard-step-four__address-input insurance-request-wizard-step-four__road-type col-md-4">
                            <OKSelect
                                label={formatText('insuranceRequestHome-step4RoadType')}
                                name="roadTypeInput"
                                options={roadTypeOptions}
                                value={roadType}
                                onChange={op => this.handleChangeRoadType(op)}
                                onBlur={this.handleRoadTypeBlur}
                                errorState={roadTypeErrorValidation}
                                errorMessage={roadTypeErrorMessage}
                                placeholder={formatText('insuranceRequestHome-selectAnOption')}
                                noResultsText={formatText('insuranceRequestHome-step2ConsultEmpty')}
                                inputProps={{ maxLength: validationsForInputs.roadType.length }}
                            />
                        </div>
                        <div className="insurance-request-wizard-step-four__address-input insurance-request-wizard-step-four__road col-md-8">
                            <OKInput
                                autoComplete="off"
                                onChange={evt => this.handleValidateField(evt, typeOfInputs.road)}
                                onBlur={evt => this.handleBlurField(evt, typeOfInputs.road)}
                                id={typeOfInputs.road}
                                errorState={!!roadErrorValidation}
                                errorMessage={formatText(`insuranceRequestHome-${roadErrorValidation}`)}
                                label={formatText('insuranceRequestHome-step4Road')}
                                placeholder={formatText('insuranceRequestHome-step4RoadPlaceholder')}
                                value={road}
                                maxLength={validationsForInputs.road.length}
                                instructionsMessage={this.buildMaxCharactersMessage('road')}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12">
                        <div className="insurance-request-wizard-step-four__address-input insurance-request-wizard-step-four__number col-md-4">
                            <OKInput
                                autoComplete="off"
                                id={typeOfInputs.number}
                                label={formatText('insuranceRequestHome-step4Number')}
                                placeholder={formatText('insuranceRequestHome-step4NumberPlaceholder')}
                                value={number || ''}
                                maxLength={validationsForInputs.number.length}
                                onChange={evt => this.handleValidateField(evt, typeOfInputs.number)}
                                onBlur={evt => this.handleBlurField(evt, typeOfInputs.number)}
                                errorState={numberErrorValidation !== ''}
                                errorMessage={formatText(`insuranceRequestHome-${numberErrorValidation}`)}
                                instructionsMessage={this.buildMaxCharactersMessage('number')}
                            />
                        </div>
                        <div className="insurance-request-wizard-step-four__address-input insurance-request-wizard-step-four__additional-info col-md-8">
                            <OKInput
                                autoComplete="off"
                                id={typeOfInputs.additionalInfo}
                                label={additionalInfoLabel}
                                placeholder={formatText('insuranceRequestHome-step4AdditionalInfoPlaceholder')}
                                value={additionalInfo}
                                onBlur={evt => this.handleBlurAdditionalInfoField(evt, typeOfInputs.additionalInfo)}
                                maxLength={validationsForInputs.additionalInfo.length}
                                onChange={evt => this.handleValidateField(evt, typeOfInputs.additionalInfo, false)}
                                errorState={additionalInfoErrorValidation !== ''}
                                errorMessage={formatText(`insuranceRequestHome-${additionalInfoErrorValidation}`)}
                                instructionsMessage={this.buildMaxCharactersMessage('additionalInfo')}
                            />
                        </div>
                    </div>
                </div>
                <div className="insurance-request-wizard-step-four row">
                    <div className="col-xs-12">
                        <div className={postalCodeClass}>
                            <OKInput
                                autoComplete="off"
                                disabled
                                id="addressPostalCodeInput"
                                label={formatText('insuranceRequestHome-postalCode')}
                                type="text"
                                value={postalCode}
                            />
                            <div className="hidden-md hidden-lg">
                                {this.renderDisclaimer(postalCodeError, POSTAL_CODE)}
                            </div>
                        </div>
                        <div className="insurance-request-wizard-step-four insurance-request-wizard-step-four__province col-md-4">
                            <OKInput
                                autoComplete="off"
                                disabled
                                id="provinceInput"
                                label={formatText('insuranceRequestHome-step4Province')}
                                value={toFirstUppercase(provinceName)}
                            />
                        </div>
                        <div className="insurance-request-wizard-step-four insurance-request-wizard-step-four__population col-md-4">
                            <OKInput
                                autoComplete="off"
                                id={typeOfInputs.population}
                                label={formatText('insuranceRequestHome-step4Population')}
                                placeholder={formatText('insuranceRequestHome-step4Population')}
                                value={toCamelCase(population)}
                                maxLength={validationsForInputs.population.length}
                                onChange={evt => this.handleValidateField(evt, typeOfInputs.population)}
                                onBlur={evt => this.handleBlurField(evt, typeOfInputs.population)}
                                errorState={populationErrorValidation !== ''}
                                errorMessage={formatText(`insuranceRequestHome-${populationErrorValidation}`)}
                                disabled={populationDisabledStatus}
                            />
                        </div>
                    </div>
                </div>
                <div className="insurance-request-wizard-step-four__change-postal-code">
                    <FormattedText value={'insuranceRequestHome-insuranceRequestHome_step4PostalCodeChangeText'} />
                    <OKButton
                        onClick={this.handleChangePostalCodeStep}
                        modifier="link-emphasize"
                        autoHeight={true}
                        size="small"
                    >
                        <FormattedText value="insuranceRequestHome-insuranceRequestHome_step4PostalCodeChangeLink" />
                    </OKButton>
                </div>
                <div className="insurance-request-wizard-step-four hidden-xs hidden-sm">
                    <div className="col-xs-12">
                        {this.renderDisclaimer(postalCodeError, POSTAL_CODE)}
                    </div>
                </div>
            </React.Fragment>
        )
    }

    buildAddressSection() {
        const { immInsuranceWizardStep } = this.props;
        const { showAddressFields, showDisclaimer, userSelectAddressNumber, geosuggestInitialValue } = this.state;
        const isAddresEmptyAndThereIsNotASelectedOption = !showDisclaimer && immInsuranceWizardStep.get('fieldErrors') && !this.props.immInsuranceWizardStep.get('road') && !this.state.showAddressFields
        const showAddressFieldsIsActive = !showAddressFields && userSelectAddressNumber === selectAddresState.no_selected
        const addressFieldError = this.state.addressError || showAddressFieldsIsActive || isAddresEmptyAndThereIsNotASelectedOption;
        const addressValidationClass = classnames('ok-input', {
            'ok-input--error': addressFieldError
        });

        const addressErrorClass = classnames('insurance-request-wizard-step-four__address-field-message', {
            'insurance-request-wizard-step-four__address-field-message--error': addressFieldError
        });
        const { ADDRESS } = DISCLAIMER_CONTEXT;
        const additionalAddressFields = showAddressFields ? this.buildAdditionalAddressFields() : null;
        return (
            <div className="row">
                <header className="insurance-request-wizard-step-four__header">
                    {formatText('insuranceRequestHome-step4livingPlaceTitle')}
                </header>
                {this.buildError()}
                <div className="insurance-request-wizard-step-four__address col-xs-12 col-sm-12">
                    <label className="ok-input__label" htmlFor="addressInput">
                        {formatText('insuranceRequestHome-step4RegularAddress')}
                    </label>
                    <div className={addressValidationClass}>
                        <Geosuggest
                            className="insurance-request-wizard-step-four__suggest-field"
                            country={TARGET_COUNTRY}
                            initialValue={geosuggestInitialValue}
                            id="addressInput"
                            inputClassName="insurance-request-wizard-step-four__input-address ok-input__input"
                            minLength={2}
                            onSuggestSelect={this.handleSelectAddress}
                            onSuggestNoResults={this.handleOnSuggestNoResults}
                            onBlur={this.handleBlurAddress}
                            onFocus={this.handleOnFocus}
                            onChange={this.handleOnChangeAddress}
                            placeholder={formatText('insuranceRequestHome-step4RoadAndNumber')}
                            ref={ref => this._geoSuggest = ref}
                            suggestsClassName="insurance-request-wizard-step-four__result-list"
                            suggestItemClassName="insurance-request-wizard-step-four__result-item"
                        />
                        <span className={addressErrorClass}>
                            {formatText('insuranceRequestHome-step4ErrorInAddress')}
                        </span>
                        {this.renderExample()}
                    </div>
                    {this.renderDisclaimer(showDisclaimer, ADDRESS)}
                    {this.renderCompleteManually()}
                </div>
                {additionalAddressFields}
            </div>
        );
    }

    buildMortgageSection() {
        const { immInsuranceWizardStep, immFlagBasedFeatures, immInsuranceChosenMortgage} = this.props;
        const hasMortgage = immInsuranceWizardStep.get('hasMortgage');
        const mortgageBank = immInsuranceWizardStep.get('mortgageBank') === null ? '' : immInsuranceWizardStep.get('mortgageBank');
        const mortgageBankError = immInsuranceWizardStep.get('fieldErrors') && hasMortgage && !mortgageBank;
        const bankInput = hasMortgage ? (
            <div className="insurance-request-wizard-step-four__has-mortgage-bank-input col-xs-12">
                <label className="insurance-request-wizard-step-four__bank-input-label">
                    <FormattedText value="insuranceRequestHome-insuranceRequestHome_mortgageBankFieldTitle" />
                </label>
                <OKAutosuggest
                    content="name"
                    dataset={immInsuranceWizardStep.get('mortgageBankList', []).toJS()}
                    datasetKey="name"
                    error={mortgageBankError}
                    errorMessage={formatText('insuranceRequestHome-step4AdditionalInfoRequiredInput')}
                    format="text"
                    highlightMatchedSuggestions
                    maxItems="8"
                    onChange={this.handleMortgageBankChange}
                    onSelect={this.handleMortgageBankSelected}
                    placeholder={formatText('insuranceRequestHome-insuranceRequestHome_mortgageBankFieldPlaceHolder')}
                    selectedValue={mortgageBank}
                    uppercase={false}
                    widthInput="big"
                />
            </div>
        ) : null;

        const isEnabledFF = immFlagBasedFeatures.get(STANDALONE_RELATED_INSURANCE);
        const contractNumber = immInsuranceChosenMortgage.getIn(['chosenMortgage', 'contractNumber']);
        const hideOptionMortgage = !(isEnabledFF && contractNumber !== undefined);

        return hideOptionMortgage && (
            <div className="insurance-request-wizard-step-four__mortgage row">
                <div className="insurance-request-wizard-step-four__has-mortgage col-xs-12">
                    <RadioButtonGroup
                        selectedValue={hasMortgage}
                        onChange={this.handleHasMortgageChange}
                        name="hasMortgageRadioGroup"
                        idPrefix="hasMortgageRadioGroup"
                        label={formatText('insuranceRequestHome-step4HasMortgage')}
                        className="insurance-request-wizard-step-four__radio-group"
                    >
                        <RadioButton
                            label={formatText('insuranceRequestHome-step4HasMortgageNo')}
                            value={false}
                        />
                        <RadioButton
                            label={formatText('insuranceRequestHome-step4HasMortgageYes')}
                            value={true}
                        />
                    </RadioButtonGroup>
                </div>
                {bankInput}
            </div>
        );
    }

    buildError() {
        const { isRelated, immInsuranceWizardStep } = this.props;
        let visibleError = false;

        if (isRelated) {
            visibleError = immInsuranceWizardStep.get('fieldErrors') &&
                !immInsuranceWizardStep.get('accountId')
        } else {
            const { addressError, numberError, roadError, additionalInfoError, populationError, showAddressFields } = this.state;
            const road = immInsuranceWizardStep.get('road')
            const addressIsEmpty = !(!!road && showAddressFields)
            visibleError = immInsuranceWizardStep.get('fieldErrors') && (
                addressError ||
                addressIsEmpty ||
                !!numberError ||
                !!roadError ||
                !!additionalInfoError ||
                !!populationError ||
                !immInsuranceWizardStep.get('startDate') ||
                !immInsuranceWizardStep.get('accountId') ||
                immInsuranceWizardStep.get('hasMortgage') && !immInsuranceWizardStep.get('mortgageBank')
            );
        }

        return visibleError && (
            <div className="col-xs-12 insurance-request-wizard-step-four__field-errors-message">
                <OKMessage type="warning">
                    <FormattedText value="insuranceRequestHome-stepValidationError" />
                </OKMessage>
            </div>
        );
    }

    buildDatePickerSection() {
        const { immInsuranceWizardStep, } = this.props;

        const selectedDate = immInsuranceWizardStep.get('startDate') ? moment(immInsuranceWizardStep.get('startDate')) : null;
        const minDate = selectedDate ? moment().startOf('day') : moment().utc().startOf('day');
        const maxDate = moment(minDate).add(MAX_DAYS_INSURANCE_INIT, 'days');
        const dateError = immInsuranceWizardStep.get('fieldErrors') && !immInsuranceWizardStep.get('startDate');

        const datePickerSection = (
            <div className="insurance-request-wizard-step-four__payment-date">
                <DatePickerCustom
                    id="insuranceStartDatePicker"
                    callback={this.onhandleDateChange}
                    label={formatText('insuranceRequestHome-step4startDate')}
                    minDate={minDate}
                    maxDate={maxDate}
                    language={getLanguage()}
                    placeholder={DATE_PICKER_CUSTOM_PLACEHOLDER}
                    locale={DATE_PICKER_CUSTOM_LOCALE}
                    dateFormat={DATE_PICKER_CUSTOM_DATE_FORMAT}
                    selectedDate={selectedDate}
                    errorState={dateError}
                    errorMessage={formatText('insuranceRequestHome-step4AdditionalInfoRequiredInput')}
                />
            </div>
        );

        return datePickerSection;
    }

    buildContactCenterMandatoryReading() {
        const { isRelated } = this.props;
        const poeditorPrefix = 'insuranceRequestHomeCC';
        const message = isRelated
            ? `${poeditorPrefix}-${poeditorPrefix}_relatedMandatoryReadingStep4`
            : `${poeditorPrefix}-${poeditorPrefix}_mandatoryReadingStep4`;

        return __CONTACT_CENTER__
            ? (
                <div className="row">
                    <BlockInfo
                        extraClass={'insurance-request-wizard-step-four__block-info'}>
                        {formatText(message)}
                    </BlockInfo>
                </div>
            )
            : null;
    }

    buildMessageByDate() {
        const {immInsuranceWizardStep, immFlagBasedFeatures} = this.props;
        const selectedDate = immInsuranceWizardStep.get('startDate');
        const POE_KEY_CC = 'insuranceRequestHome-insuranceRequestHome_step4HomeFreeCC';
        const POE_KEY_WEB = 'insuranceRequestHome-insuranceRequestHome_step4HomeFreePrivate';
        const MessageContainer = __CONTACT_CENTER__ ? BlockInfo : OKMessage;
        let poeKey;

        if (immFlagBasedFeatures.get(INSURANCE_IDD_REGULATION)) {
            poeKey = __CONTACT_CENTER__ ? POE_KEY_CC : POE_KEY_WEB;
        }

        return !!poeKey && !!selectedDate &&(
            <MessageContainer>
                <FormattedText value={poeKey} />
            </MessageContainer>
        );
    }

    render() {
        const {
            getBlockedAccounts,
            immAccounts,
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizardStep,
            isRelated,
            resetBlockedAccounts,
            setData,
        } = this.props;
        if (immInsuranceState.get('hasFetched') && immInsuranceState.get('isFetching') || immAccounts.get('blockedAccountsLoading')) {
            return <LoadingSection />
        }

        const populationWarning = !!this.state.oldPricing && !isEqual(this.state.oldPricing, immInsuranceWizardStep.get('totalCost'));
        const paymentSelected = immInsuranceWizardStep.get('paymentType');
        const isBlockedAccountsEnabled = immFlagBasedFeatures.get(WEB_INACTIVE_ACCOUNT_ENABLED);

        return (
            <div className="insurance-request-wizard-step-four">
                {this.buildContactCenterMandatoryReading()}
                {!isRelated && this.buildAddressSection()}
                <InsuranceRequestBuildPaymentType
                    paymentSelected={paymentSelected}
                    immInsuranceState={immInsuranceState}
                    immInsuranceWizardStep={immInsuranceWizardStep}
                    isRelated={isRelated}
                    onhandlePaymentTypeChange={this.onhandlePaymentTypeChange}
                    buildError={this.buildError}
                />
                <div className="insurance-request-wizard-step-four__pricing-change-message">
                    <OKMessage
                        type="important"
                        visible={populationWarning}
                    >
                        <FormattedText
                            value="insuranceRequestHome-insuranceRequestHome_step4MismatchedPopulation"
                        />
                    </OKMessage>
                </div>
                {!isRelated &&
                    <InsuranceRequestWizardStep4DatePicker
                        immInsuranceWizardStep={immInsuranceWizardStep}
                        onhandleDateChange={this.onhandleDateChange}
                    />
                }
                {this.buildMessageByDate()}
                <InsuranceRequestWizardStep4AccountSection
                    getBlockedAccounts={getBlockedAccounts}
                    immInsuranceWizardStep={immInsuranceWizardStep}
                    immAccounts={immAccounts}
                    isBlockedAccountsEnabled={isBlockedAccountsEnabled}
                    isRelated={isRelated}
                    onhandleAccountChange={this.onhandleAccountChange}
                    resetBlockedAccounts={resetBlockedAccounts}
                    setData={setData}
                />
                {!isRelated && this.buildMortgageSection()}
                <div className="row">
                    <div className="insurance-request-wizard-step-four__gdpr col-xs-12">
                        <InsuranceRequestWizardGDPRMessage />
                    </div>
                </div>
            </div>
        );
    }
}

InsuranceRequestWizardStep4.propTypes = {
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    immInsuranceChosenMortgage: PropTypes.object,
    isRelated: PropTypes.bool,
    postalCode: PropTypes.string,
    getAddressTypeList: PropTypes.func,
    getBlockedAccounts: PropTypes.func.isRequired,
    getMortgageBanks: PropTypes.func,
    getPaymentAccount: PropTypes.func.isRequired,
    goBackStep: PropTypes.func.isRequired,
    requestInsuranceProvinces: PropTypes.func,
    resetBlockedAccounts: PropTypes.func.isRequired,
    saveStep: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
};

module.exports = InsuranceRequestWizardStep4;
